import { observer } from "mobx-react";
import React, {useCallback, useMemo} from "react";
import {
  RetryRowWrapper,
  ActionsWrapper,
  InputWrapper,
  LabelWrapper,
  NumberInputWrapper,
  TimeInputWrapper,
  UnitSelectWrapper
} from "./RetryComponent.styled";
import {IconButton} from "../../../../../../../elements";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {MenuItem, Select} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {useStore} from "../../../../../../../hooks";

const RetryRow = observer(({
  index,
}) => {
  const { marketingStore } = useStore();
  const { retryStore } = marketingStore;
  const retry = retryStore.getOne({ index });
  
  const onHandleRemove = useCallback(() => {
    retryStore.remove({ index });
  }, [index]);
  
  const onHandleGetRetryTemplateMessage = useCallback(() => {
    retryStore.getRetryTemplate({ index });
  }, [index]);
  
  const onHandleExpandedEditor = useCallback(() => {
    retryStore.expandEditor({ index });
  }, [index]);
  
  const onHandleUpdateAttribute = useCallback((field, value) => {
    retryStore.updateRetryAttribute({ index, field, value });
  }, [index]);

  const onHandleIncrementOrDecrementValue = (valueIncrementOrDecrement) => {
    const retryValue = Math.min(10, Math.max(1, retry.value + valueIncrementOrDecrement));
    onHandleUpdateAttribute("value", retryValue);
  };
  
  const actions = useMemo(() => [
    {
      icon: "iconLess",
      title: "Delete retry",
      onClick: onHandleRemove
    },
    {
      icon: "iconUpdate",
      title: "Update retry with template from store",
      onClick: onHandleGetRetryTemplateMessage
    },
    {
      icon: "iconAdd",
      title: retry.isExpanded ? "Close Editor" : "Edit retry in Template Editor",
      onClick: onHandleExpandedEditor
    }
  ], [index]);

  const units = useMemo(() => [
    { value: "hours", label: "Hours" },
    { value: "days", label: "Days" },
    { value: "months", label: "Months" },
    { value: "years", label: "Years" },
  ], []);
  
  return(
    <RetryRowWrapper>
      <InputWrapper>
        <LabelWrapper>
          <label>Delivery Schedule</label>
          <IconButton icon={"iconInformation"} height="16px" width="16px" />
        </LabelWrapper>
        <TimeInputWrapper>
          <NumberInputWrapper>
            <input
              type="number"
              value={retry.value}
              onChange={(e) => onHandleUpdateAttribute("value",  e.target.value)}
              min={1}
              max={10}
            />
            <div className="arrows">
              <KeyboardArrowUpIcon onClick={() => onHandleIncrementOrDecrementValue(1)} />
              <KeyboardArrowDownIcon onClick={() => onHandleIncrementOrDecrementValue(-1)} />
            </div>
          </NumberInputWrapper>
          <UnitSelectWrapper>
            <Select
              value={retry.unit}
              onChange={(e) => onHandleUpdateAttribute("unit", e.target.value)}
              size="small"
              fullWidth
            >
              {units.map((unit) => (
                <MenuItem key={unit.value} value={unit.value}>
                  {unit.label}
                </MenuItem>
              ))}
            </Select>
          </UnitSelectWrapper>
        </TimeInputWrapper>
      </InputWrapper>
      <InputWrapper>
        <LabelWrapper>
          <label>Message</label>
          {retry.isGeneratingRetryMessage && (<CircularProgress size={16} />)}
        </LabelWrapper>
        <textarea
          value={retry.tempContent}
          onChange={(e) => onHandleUpdateAttribute("tempContent", e.target.value)}
          rows={4}
        />
      </InputWrapper>
      <ActionsWrapper>
        {actions.map((action) => (
          <IconButton
            icon={action.icon}
            height="25px"
            width="25px"
            onClick={() => action.onClick()}
            title={action.title}
          />  
        ))}
      </ActionsWrapper>
    </RetryRowWrapper>
  );
});

export default RetryRow;